package data;

import data.Parts.ConsoleType;
import haxe.ds.Vector;
import cerastes.file.CDParser;
import cerastes.Utils;
import cerastes.CMath;
import cerastes.LocalizationManager.LocalizedString;


@:structInit class RepairDef
{
	public var day: Int = 0;
	public var console: ConsoleType = 0;
	public var seed: Int = 1;
	public var difficulty: Int = 1;
}

@:structInit class RepairFile
{
	public var version: Int = 1;

	@serializeType("data.RepairDef")
	public var repairs: Array<RepairDef> = [];
}

class Repairs
{
	static var repairs: Array<RepairDef>;
	public static function init()
	{
		var data: RepairFile = CDParser.parse( hxd.Res.data.repairs.entry.getText(), RepairFile );

		repairs = data.repairs;
	}

	public static function getRepairs( day: Int ) : Array<RepairDef>
	{
		var out = [];
		for( r in repairs )
		{
			if( r.day == day )
				out.push(r);
		}

		return out;
	}
}